import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from 'react-router-dom';
import AppContext from "../context/AppContext";
import toast from "react-hot-toast";
import GlobalVolumen from "../components/GlobalVolumen";
import PackageCard from "../components/PackageCard";
import Cookies from "js-cookie"; // Importa la librería de cookies
import LanguageAndNotificacions from "../components/LanguageAndNotificacions";
import CardBackground from "../assets/svg/div-ctx.svg";
import UnilevelCard from "../assets/svg/cards/unilevel-card.svg"
import TotalCard from "../assets/svg/cards/total-card.svg"
import RankCard from "../assets/svg/cards/rank-card.svg"
import RangeCard from "../assets/svg/cards/range-card.svg"
import PlanCard from "../assets/svg/cards/plan-card.svg"
import MatchingCard from "../assets/svg/cards/matching-card.svg"
import DepositCard from "../assets/svg/cards/deposit-card.svg"
import CopyCard from "../assets/svg/cards/copy-card.svg"
import BinaryCard from "../assets/svg/cards/binary-card.svg"
import BarCard from "../assets/svg/cards/bar-card.svg"
import CTXFlix from "../assets/svg/cards/ctxflix-card.svg"
import CTXSignal from "../assets/svg/cards/ctxsignal-card.svg"
import CTXCopy from "../assets/svg/cards/ctxcopy-card.svg"
import CTXII from "../assets/svg/cards/ctxii-card.svg"
import LogoCTFLIX from "../assets/svg/ctflix-logo.svg"
import LogoCTSignals from "../assets/svg/ctxsignals-logo.png"
import LogoCTCopy from "../assets/svg/copy-logo.svg"
import LogoCTII from "../assets/svg/ctxii-logo.svg"
import Card from "../assets/svg/card.svg"

import EllipseGreen from "../assets/svg/ellipse/ellipse-green.svg"
import EllipsePurple from "../assets/svg/ellipse/ellipse-purple.svg"
import EllipseOrange from "../assets/svg/ellipse/ellipse-orange.svg"

import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, ArcElement, Legend } from 'chart.js';
import { format } from "date-fns";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, ArcElement, Tooltip, Legend);

export default function Home() {
  const { t } = useTranslation();
  const { loading, updateLoading, showShareOptions } = useContext(AppContext);
  const navigate = useNavigate();
  const [percentage, setPercentage] = useState(0);
  const [userData, setUserData] = useState([]);
  const [rangeData, setRangeData] = useState([]);
  const [packagesOperation, setPackagesOperation] = useState([]);
  const [hoursServer, setHoursServer] = useState();
  const [balance, setBalance] = useState(0);
  const [balanceTotal, setBalanceTotal] = useState(0);
  const [earningsTotal, setEarningsTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [total, setTotal] = useState(0);
  const [accelerateButton, setAccelerateButton] = useState(Cookies.get(`accelerate`) ? true : false);
  useEffect(() => {
    getUsersData();
    getNotificationsPackages();
  }, []);

  const getUsersData = () => {
    updateLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND}/users`, {
      method: "GET",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        const data = response?.data;
        setUserData(data);
        setRangeData(response?.range)
        if (data && data.package_value_maximun && data.package_value_current) {
          const max = data.package_value_maximun;
          const current = data.package_value_current;
          const calculatedPercentage = (current / max) * 100;
          setPercentage(calculatedPercentage);
        }
        setBalance(parseFloat(data?.balance_available) + parseFloat(data?.balance_referral) + parseFloat(data?.balance_binary) + parseFloat(data?.balance_matching) + parseFloat(data?.balance_bonus) + parseFloat(data?.balance_residual));
        setEarningsTotal(parseFloat(data?.total_available) + parseFloat(data?.total_referral) + parseFloat(data?.total_binary) + parseFloat(data?.total_matching) + parseFloat(data?.total_bonus) + parseFloat(data?.total_residual));
        setHoursServer(response?.hour);
        updateLoading(false);
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  }

  const getNotificationsPackages = () => {
    updateLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND}/notification-earnings?page=${page}&limit=${limit}`, {
      method: "GET",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        const data = response?.data?.items;
        if (data) {
          setPackagesOperation(data); // Establecer los datos agrupados y sumados
          setTotal(response?.data?.total)
        }
        updateLoading(false);
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  }

  useEffect(() => {
    getNotificationsPackages();
  }, [page, limit]);



  const goToPackages = () => {
    navigate("/packages");
  }


  const oraculo = (props) => {
    if (window.localStorage.getItem("tron")) {
      let value = props / window.localStorage.getItem("tron");
      let fomart = Number.parseFloat(value).toFixed(3);
      let valueFormat = formatNumber(fomart);
      return valueFormat;
    }
  };

  const formatNumber = (value) => {
    if (value >= 1000000) {
      return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (value >= 1000) {
      return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    const valueString = value.toString();
    const [integerPart, decimalPart] = valueString.split('.');

    if (decimalPart && decimalPart.length > 2) {
      return `${integerPart}.${decimalPart.slice(0, 2)}`;
    }

    return valueString;
  };


  const goToAccelerate = () => {
    Cookies.set('accelerate', true, { expires: 1 / 96 });
    setAccelerateButton(true);
    fetch(`${process.env.REACT_APP_BACKEND}/deposit`, {
      method: "POST",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        toast.success(t("_AUTH._SUCCESS"));
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  }

  const goToWithdrawal = (type) => {
    const formData = new FormData();
    formData.append("type", type);
    updateLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND}/withdrawal`, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (!response.status) {
          if (response.processing === true) {
            toast.error(t("_WITHDRAWAL._ERRORPROCESS")); // Ya tienes otro retiro en proceso espera unos minutos
          } else if (response.withdrawal_address === true) {
            toast.error(t("_WITHDRAWAL._ERRORWALLET")); //Debes configurar primero tu billetera de retiro Solana
          } else if (response.balance === true) {
            toast.error(t("_WITHDRAWAL._PACKA_ERRORBALANCEGEMESSAGE")); //Balance negativo vuelve a itnentarlo.
          } else {
            toast.error(t("_WITHDRAWAL._ERROROTHER")); //Vuelve a intentarlo.
          }
          getUsersData();
          updateLoading(false);
        } else {
          toast.success(t("_WITHDRAWAL._SUCCESS"));
          getUsersData();
          updateLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  }



  const openReferralLink = () => {
    showShareOptions(true);
  }
  return (
    <div className="container-full">
      {/** Inicio de Noticias    **/}
      <div className="flex flex-row w-full gap-4">
        <div className="flex flex-col w-full lg:w-2/3 gap-3">
          <div><h1 className="text-white text-3xl">   {t("_NOTICE._NOTICE")}</h1></div>
          <div className="w-full bg-black rounded-lg h-80 flex flex-col lg:flex-row p-6" >
            <div className="flex flex-col justify-center items-center w-full lg:w-3/5 relative">
              <h1 className="text-3xl lg:text-5xl text-ctx"> {t("_NOTICE._CRYPTOCARD")}</h1>
              <div className="flex flex-row justify-center items-center">
                <p className="text-md text-white">
                  {t("_NOTICE._DESCRIPTION")}
                  <br /><br />
                </p>
              </div>
            </div>
            <div className="flex justify-center items-center ">
              <video width="750" height="400" controls >
                <source src="https://cryptotradex.s3.us-west-1.amazonaws.com/cryptocard/card.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>

        <div className="hidden lg:flex flex-col w-1/3  gap-3 " >
          <div><h1 className="text-white text-2xl">{t("_NOTICE._NEW")}</h1></div>
          <div className="w-full bg-black rounded-md h-80 bg-cover bg-no-repeat flex justify-center items-center flex-col gap-2" style={{ backgroundImage: `url(${Card})` }}>
            <h1 className="text-white text-4xl uppercase text-center mx-8">{t("_NOTICE._DISCOVERY")}<span className="text-ctx">{t("_NOTICE._YOU")}.</span></h1>
            <a href="https://cryptoxperience.com/" target="_blank" rel="noreferrer">
              <button className="text-white p-2 rounded-lg border-white group-hover:border-white border-2 shim-black px-6 my-2">{t("_DASHBOARD._ENTER")}</button>
            </a>
          </div>
        </div>

      </div>

      <div className="absolute top-4 right-16">
        <LanguageAndNotificacions />
      </div>
      {/** Fin  de Noticias */}
      {/** Inicio de Estadisticas */}
      <div className="flex flex-col lg:flex-row w-full gap-4 my-4 justify-between mt-10">
        <div className="w-full lg:w-1/5 gap-3">
          <h1 className="text-white text-3xl">{t("_NOTICE._MYBUSINESS")}</h1>
        </div>
        {
          userData?.active === "1" && (
            <div className="glowing-border w-full lg:w-auto gap-3 flex flex-row justify-center items-center bg-cover h-12 p-4  border-zinc-700 border-2 rounded-xl bg-cover text-white cursor-pointer relative" style={{ backgroundImage: `url(${CardBackground})` }} onClick={() => openReferralLink()}>
              <p className="text-white">{t("_DASHBOARD._SHARED")}</p>
            </div>
          )}
      </div>
      <div className="my-8 flex flex-col lg:flex-row gap-2">
        <div className="lg:w-1/3 w-full flex flex-col gap-2">
          <div className="flex gap-2 w-full">
            {/** Unilevel */}
            <div className="w-1/2 h-48 p-4 flex flex-col justify-between border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white" style={{ backgroundImage: `url(${UnilevelCard})` }} >
              <h1 className="text-sm">{t("_DASHBOARD._TITLE7")} </h1>
              {parseInt(userData?.balance_referral) >= 10 && (
                <button className="glowing-border text-md w-auto border-2 p-1 cursor-pointer rounded-lg px-2 hover:bg-black/50" onClick={() => goToWithdrawal('balance_referral')}>{t("_WITHDRAWINVESTMENT._BUTTON")} </button>
              )}
              <div className="group gap-2 flex flex-col ">
                <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row gap-2 text-white w-full flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{formatNumber(userData?.balance_referral || 0)}</p>
                  <p className="w-2/5">USD</p>
                </div>
                <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> {formatNumber(userData?.total_referral || 0)}</p>
                  <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                </div>
                <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.balance_referral)}</p>
                  <p className="w-2/5">SOL</p>
                </div>
                <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.total_referral)}</p>
                  <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                </div>
              </div>
            </div>
            {/** Binario */}
            <div className="w-1/2 h-48 p-4 flex flex-col justify-between border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white" style={{ backgroundImage: `url(${BinaryCard})` }}>
              <h1 className="text-sm">{t("_DASHBOARD._TITLE8")}</h1>
              {parseInt(userData?.balance_binary) >= 10 && (
                <button className="glowing-border text-md w-auto border-2 p-1 cursor-pointer rounded-lg px-2 hover:bg-black/50" onClick={() => goToWithdrawal('balance_binary')}>{t("_WITHDRAWINVESTMENT._BUTTON")} </button>
              )}
              <div className="group gap-2 flex flex-col ">
                <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row gap-2 text-white w-full flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{formatNumber(userData?.balance_binary || 0)}</p>
                  <p className="w-2/5">USD</p>
                </div>
                <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> {formatNumber(userData?.total_binary || 0)}</p>
                  <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                </div>
                <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.balance_binary)}</p>
                  <p className="w-2/5">SOL</p>
                </div>
                <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.total_binary)}</p>
                  <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-2 w-full">
            {/** Deposito  */}
            <div className="w-1/2 h-48 p-4 flex flex-col justify-between border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white" style={{ backgroundImage: `url(${DepositCard})` }}>
              <h1 className="text-sm">{t("_DASHBOARD._TITLE2")}</h1>
              {!accelerateButton && (
                <button className="text-md w-auto border-2 p-1 cursor-pointer rounded-lg px-2" onClick={() => goToAccelerate()}>{t("_SYSTEM._ACCELERATE")} </button>
              )}
              <div className="group gap-2 flex flex-col ">
                <div className="flex transition-opacity duration-300 opacity-100  flex-row gap-2 text-white w-full flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{formatNumber(userData?.balance_deposit || 0)} </p>
                  <p className="w-2/5">SOL</p>
                </div>
                <div className="flex transition-opacity duration-300 opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> {formatNumber(userData?.total_deposit || 0)} </p>
                  <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                </div>
              </div>
            </div>
            {/** Binario Residual */}
            <div className="w-1/2 h-48 p-4 flex flex-col justify-between border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white" style={{ backgroundImage: `url(${MatchingCard})` }}>
              <h1 className="text-sm">{t("_DASHBOARD._TITLE9")}</h1>
              {parseInt(userData?.balance_residual) >= 10 && (
                <button className="glowing-border text-md w-auto border-2 p-1 cursor-pointer rounded-lg px-2 hover:bg-black/50" onClick={() => goToWithdrawal('balance_residual')}>{t("_WITHDRAWINVESTMENT._BUTTON")} </button>
              )}
              <div className="group gap-2 flex flex-col ">
                <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row gap-2 text-white w-full flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{formatNumber(userData?.balance_residual || 0)}</p>
                  <p className="w-2/5">USD</p>
                </div>
                <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> {formatNumber(userData?.total_residual || 0)}</p>
                  <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                </div>
                <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.balance_residual)}</p>
                  <p className="w-2/5">SOL</p>
                </div>
                <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.total_residual)}</p>
                  <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-1/3 w-full gap-2">
          <div className="flex flex-col gap-2 w-full">
            <div className="w-full h-72 border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white flex items-end" style={{ backgroundImage: `url(${RankCard})` }}>
              <GlobalVolumen userData={userData} rangeData={rangeData} />
            </div>
            <div className="w-full h-24 border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white relative" style={{ backgroundImage: `url(${BarCard})` }}>
              <div className="flex justify-between my-2 m-5">
                <p className="text-sm text-end">{t("_DASHBOARD._FINISH")}: {userData?.package_value_maximun || 0} USD</p>
              </div>
              <div className="relative h-4 rounded-2xl overflow-hidden bg-gray-300 my-2 mx-5">
                <div className="absolute top-0 h-4 rounded-2xl shim-green"
                  style={{ width: `${percentage}%` }}>
                </div>
              </div>
              <div className="mx-5 flex flex-row justify-between my-2">
                <div className="flex flex-row justify-center items-center">
                  <p className="hidden lg:block text-sm"> {t("_DASHBOARD._STATUS")}: {userData?.active === "1" ? t("_DASHBOARD._STATUS_ACTIVE") : t("_DASHBOARD._STATUS_INACTIVE")}</p>
                </div>
                <p className="text-sm"> {t("_DASHBOARD._CURRENT")}: {userData?.package_value_current ? userData?.package_value_current : "0"} USD - {percentage ? percentage.toFixed(2) : "0"}%</p>
              </div>
              {userData?.package !== "8" && (

                <div className="flex flex-row hidden lg:block absolute -bottom-11 left-1/2 -translate-x-1/2 cursor-pointer z-40">
                  <button className="text-md w-auto border-r-2 p-2 cursor-pointer rounded-b-xl bg-green-400 text-black" onClick={() => goToPackages()}>
                    {t("_DASHBOARD._UPGRADE")}
                  </button>
                </div>

              )}
            </div>
          </div>
        </div>
        <div className="lg:w-1/3 w-full flex flex-col gap-2">
          <div className="flex gap-2 w-full">
            {/** Rango Infinito */}
            <div className="w-1/2 h-48 p-4 flex flex-col justify-between border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white" style={{ backgroundImage: `url(${RangeCard})` }}>
              <h1 className="text-sm">{t("_DASHBOARD._TITLE5")}</h1>
              {parseInt(userData?.balance_bonus) >= 10 && (
                <button className="glowing-border text-md w-auto border-2 p-1 cursor-pointer rounded-lg px-2 hover:bg-black/50" onClick={() => goToWithdrawal('balance_bonus')}>{t("_WITHDRAWINVESTMENT._BUTTON")} </button>
              )}
              <div className="group gap-2 flex flex-col ">
                <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row gap-2 text-white w-full flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{formatNumber(userData?.balance_bonus || 0)}</p>
                  <p className="w-2/5">USD</p>
                </div>
                <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> {formatNumber(userData?.total_bonus || 0)}</p>
                  <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                </div>
                <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.balance_bonus)}</p>
                  <p className="w-2/5">SOL</p>
                </div>
                <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.total_bonus)} </p>
                  <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                </div>
              </div>
            </div>
            {/** Balance Matching Bonus COPY */}
            <div className="w-1/2 h-48 p-4 flex flex-col justify-between border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white" style={{ backgroundImage: `url(${CopyCard})` }}>
              <h1 className="text-sm">{t("_DASHBOARD._TITLE10")}</h1>
              {parseInt(userData?.balance_matching) >= 10 && (
                <button className="glowing-border text-md w-auto border-2 p-1 cursor-pointer rounded-lg px-2 hover:bg-black/50" onClick={() => goToWithdrawal('balance_matching')}>{t("_WITHDRAWINVESTMENT._BUTTON")} </button>
              )}
              <div className="group gap-2 flex flex-col ">
                <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row gap-2 text-white w-full flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{formatNumber(userData?.balance_matching || 0)}</p>
                  <p className="w-2/5">USD</p>
                </div>
                <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> {formatNumber(userData?.total_matching || 0)}</p>
                  <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                </div>
                <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.balance_matching)}</p>
                  <p className="w-2/5">SOL</p>
                </div>
                <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.total_matching)} </p>
                  <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-2 w-full">
            <div className="w-1/2 h-48 p-4 flex flex-col justify-between border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white relative group" style={{ backgroundImage: `url(${PlanCard})` }}>
              <PackageCard userData={userData} goToWithdrawal={goToWithdrawal} />
            </div>
            <div className="w-1/2 h-48 p-4 flex flex-col justify-between border-zinc-700 hover:border-zinc-400 border-2 rounded-xl bg-cover text-white" style={{ backgroundImage: `url(${TotalCard})` }}>
              <h1 className="text-sm">{t("_DASHBOARD._TITLE3")}</h1>
              {balance > 0 && (
                <button className="text-md w-auto  cursor-pointer rounded-lg px-2 text-lime-400  flex justify-center gap-2" >
                  {formatNumber(balance || 0)}
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941" />
                  </svg>
                </button>
              )}
              <div className="group gap-2 flex flex-col ">
                <div className="flex transition-opacity duration-300 opacity-100 flex-row gap-2 text-white w-full flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{formatNumber(earningsTotal || 0)}</p>
                  <p className="w-2/5">USD</p>
                </div>
                <div className="flex transition-opacity duration-300 opacity-100 flex-row  gap-2 text-white w-full  flex-end">
                  <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> {formatNumber(earningsTotal || 0)}</p>
                  <p className="w-2/5">SOL</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/** Productos */}
      <div className="flex flex-col lg:flex-row w-full gap-4 my-4 justify-between">
        <div className="w-full lg:w-1/5 gap-3">
          <h1 className="text-white text-3xl">{t("_NOTICE._MYPRODUCTS")}</h1>
        </div>
      </div>
      <div className="hidden lg:flex flex-col lg:flex-row gap-4 my-10 z-10">
        <div className="z-10 relative lg:w-4/12 h-auto">
          <img src={EllipseOrange} alt="Ellipse Orange" className="z-2 absolute -top-40" />
        </div>
        <div className="z-10 relative lg:w-4/12 h-auto">
          <img src={EllipseGreen} alt="Ellipse Green" className="z-2 absolute -top-40" />
        </div>
        <div className="z-10 relative lg:w-4/12 h-auto">
          <img src={EllipsePurple} alt="Ellipse Purple" className="z-2 absolute -top-40" />
        </div>
      </div>
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="z-20 flex flex-col p-4 items-center text-white lg:w-4/12 h-[43rem] hover:opacity-100 opacity-70 xs:opacity-100 group bg-cover border-zinc-800 hover:border-white border-2 rounded-xl" style={{ backgroundImage: `url(${CTXFlix})` }}>
          <img src={LogoCTFLIX} alt={"CTFLIX"} className="mt-10 w-56 h-10" />
          <p className="mt-20 px-4  text-center h-44 font-sans text-xl">{t("_DASHBOARD._CTFLIX")}</p>
          <Link to="/ctflix">
            <button className="p-2 rounded-lg border-zinc-800 group-hover:border-zinc-600 border-2 shim-black px-6 ">{t("_DASHBOARD._ENTER")}</button>
          </Link>
        </div>
        <div className="z-20 flex flex-col p-4 items-center text-white lg:w-4/12 h-[43rem] hover:opacity-100 opacity-70 xs:opacity-100 group bg-cover border-zinc-800 hover:border-white border-2 rounded-xl" style={{ backgroundImage: `url(${CTXSignal})` }}>
          <img src={LogoCTSignals} alt={"Signals"} className="w-56 h-30" />
          <p className="mt-10 px-4  text-center h-44 font-sans text-xl">{t("_DASHBOARD._SIGNAL")}</p>
          {userData?.package <= 3 ?
            <>
              <button className="p-2 rounded-lg border-zinc-800 group-hover:border-zinc-600 border-2 shim-black px-6 text-white" onClick={() => goToPackages()}>{t("_DASHBOARD._UPGRADE")}</button>
            </>
            :
            <>
              <Link to="/signals">
                <button className="p-2 rounded-lg border-zinc-800 group-hover:border-zinc-600 border-2 shim-black px-6 ">{t("_DASHBOARD._ENTER")}</button>
              </Link>
            </>
          }
        </div>
        <div className="z-20 flex flex-col p-4 items-center text-white lg:w-4/12 h-[43rem] hover:opacity-100 opacity-70 xs:opacity-100 group bg-cover border-zinc-800 hover:border-white border-2 rounded-xl" style={{ backgroundImage: `url(${CTXCopy})` }}>
          <img src={LogoCTCopy} alt={"Copy"} className="mt-10 w-56 h-30" />
          <p className="mt-4 px-4 text-center h-44 font-sans text-xl">{t("_DASHBOARD._COPY")}</p>
          {userData?.package <= 4 ?
            <>
              <button className="p-2 rounded-lg border-zinc-800 group-hover:border-zinc-600 border-2 shim-black px-6 text-white" onClick={() => goToPackages()}>{t("_DASHBOARD._UPGRADE")}</button>
            </>
            :
            <>
              <Link to="/copy">
                <button className="p-2 rounded-lg border-zinc-800 group-hover:border-zinc-600 border-2 shim-black px-6 text-white">{t("_DASHBOARD._ENTER")}</button>
              </Link>
            </>
          }
        </div>
        <div className="z-20 flex flex-col p-4 items-center text-white lg:w-4/12 h-[43rem] hover:opacity-100 opacity-70 xs:opacity-100 group bg-cover border-zinc-800 hover:border-white border-2 rounded-xl" style={{ backgroundImage: `url(${CTXII})` }}>
          <img src={LogoCTII} alt={"CTXII"} className="mt-20" />
          <p className="mt-16 px-4  text-center h-44 font-sans text-xl">{t("_DASHBOARD._CTXII")}</p>
          {userData?.package <= 2 ?
            <>
              <button className="p-2 rounded-lg border-zinc-800 group-hover:border-zinc-600 border-2 shim-black px-6 text-white" onClick={() => goToPackages()}>{t("_DASHBOARD._UPGRADE")}</button>
            </>
            :
            <>
              <button className="p-2 rounded-lg border-zinc-800 group-hover:border-zinc-600 border-2 shim-black px-6 ">{t("_DASHBOARD._ENTER")}</button>
            </>
          }
        </div>
      </div>
      {/** Fin de productos  */}
      {/** Fin de Estadisticas 
      <div className="flex flex-col lg:flex-row gap-8 h-auto">
        <div className="flex flex-col w-full lg:w-[78%] gap-4 lg:min-h-full lg:h-auto justify-between">
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="w-full h-[12.5rem] lg:w-1/3  rounded-lg shadow-md text-white bg-cover border-lime-600 border-2 bg-no-repeat group flex flex-col justify-between" >
              <h1 className="text-white text-2xl p-4">{t("_DASHBOARD._TITLE4")} </h1>
              <div className="flex justify-between items-center">
                <div></div>
                <div className="flex flex-col h-auto text-end justify-end font2 text-xl text-white  bg-zinc-900/80 lg:bg-transparent w-full px-4">
                  <p className="block group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0">{formatNumber(userData?.balance_referral || 0)} USD </p>
                  <p className="block group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0">{formatNumber(userData?.total_referral || 0)} {t("_DASHBOARD._TOTAL")} </p>
                  <p className="hidden group-hover:block transition-opacity duration-300 opacity-0 group-hover:opacity-100">{oraculo(userData?.balance_referral)}  SOL </p>
                  <p className="hidden group-hover:block transition-opacity duration-300 opacity-0 group-hover:opacity-100">{oraculo(userData?.total_referral)}{t("_DASHBOARD._TOTAL")} </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
*/}

    </div >
  );
}
